import React from 'react';
import globals from "../globals";
import HelmetDefault from "../layout/HelmetDefault";
import Hero from "../modules/Hero/Hero";
import RegisterBlock from "../modules/RegisterBlock";
import Table from "../modules/Table";
import OutageGuarantee from "../modules/OutageGuarantee";
import TwinColumn from "../modules/TwinColumn";

class InternationalNetworks extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			title: '',
			subTitle: '',
			leadCopy: [],
			seoTitle: '',
			seoDescription: '',
			serviceAgreement: {},
			twinColumn: {}
		}
	}

	componentDidMount() {
		this.getData();
	}

	getData() {
		fetch('/api/network-solutions/international-networks')
			.then(result => result.json())
			.then((result) => {
				this.setState(result);
				this.setDataReceived();
				globals.animatePageIn(this.container);
			});
	}

	setDataReceived() {
		this.setState({
			dataReceived: true
		});
	}

	render() {
		const Heading1 = <h3>{this.state.twinColumn.heading1}</h3>;
		const Heading2 = <h3>{this.state.twinColumn.heading2}</h3>;

		return (
			<div ref={(el) => this.container = el} style={{opacity: 0}} className="international-networks">
				<HelmetDefault {...this.state} />
				<Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
				<TwinColumn data={this.state.twinColumn} heading1={Heading1} heading2={Heading2} />
				<Table data={this.state.serviceAgreement} image="/images/suitcase-dude.png" />
				<OutageGuarantee />
				<RegisterBlock />
			</div>
		);
	}

}

export default InternationalNetworks;


// WEBPACK FOOTER //
// ./resources/assets/js/networkSolutions/InternationalNetworks.js